import React from 'react';
import { useAuth } from '~/hooks/auth';

import { useAdminAuth } from '~/hooks/adminAuth';
import IndexRoutes from './index.routes';
import CompanyRoutes from './company.routes';
import ColaboratorRoutes from './colaborator.routes';
import AdminRoutes from './admin.routes';
import { useSettings } from '~/hooks/settings';

const Routes: React.FC = () => {
  const { user, company } = useAuth();
  const { company: companySettings } = useSettings();
  const { user: admin } = useAdminAuth();

  if (company.is_blocked || companySettings.is_blocked) {
    return <p className="m-2">Serviço Indisponível.</p>;
  }

  if (admin && admin.uid) return <AdminRoutes />;
  if (user && user.uid && user.isAdmin) return <CompanyRoutes />;
  if (user && user.uid && !user.isAdmin) return <ColaboratorRoutes />;

  return <IndexRoutes />;
};

export default Routes;
